import React from 'react'
import { place1Icon, place2Icon, place3Icon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import style from '../styles/cabinet_certificate.module.scss'

interface IProps {
  place?: string
}

const PlaceBlock = ({ place = '' }: IProps): React.ReactElement => {
  let placeIcon: string

  switch (place) {
    case '1': {
      placeIcon = place1Icon
      break
    }
    case '2': {
      placeIcon = place2Icon
      break
    }
    case '3': {
      placeIcon = place3Icon
      break
    }
    default: {
      placeIcon = ''
      break
    }
  }
  return (
    <div className={`${style.place} ${style.cert_block}`}>
      {placeIcon !== '' ? <GxIcon src={placeIcon} className={style.place__icon} /> : null}
      <span className={style.place__text}>{place} место</span>
    </div>
  )
}

export default PlaceBlock
